import { TableCell, TableCellProps } from "@mui/material";

export default (props: SBTableCellProps) => {
	return <TableCell {...props} />;
};

export interface SBTableCellProps extends TableCellProps {}
